export const ROUTE_PATH_ELO ="/elo";

export const STORAGE_URL_PREFIX = `elo/`;


export const FILTER_ALL = "ALL";
export const FILTER_CURRENT_SEASON = "CURRENT_SEASON";
export const FILTER_PREVIOUS_SEASON = "PREVIOUS_SEASON";
export const FILTER_PAST_MONTH = "PAST_MONTH"